{
  "title": "Signature templates",
  "subtitle": "A template is a signature design; rules decide who gets which one.",
  "templates": "Templates",
  "newTemplate": "New template",
  "loadError": "Could not load templates",
  "loadTemplateError": "Could not load the template",
  "emptyTitle": "No templates yet",
  "emptyBody": "A template is the HTML signature stamped onto outbound mail. Create one to open the designer.",
  "save": "Save",
  "publish": "Publish",
  "publishHint": "Compiles this design and queues it for outbound mail. Save alone does not change what recipients see.",
  "published": "Published as v{{version}}. Signatures will update within a few seconds.",
  "publishFailed": "Publish failed.",
  "preview": "Preview",
  "undo": "Undo",
  "redo": "Redo",
  "export": "Export",
  "exportHint": "Download this design as a JSON file you can import into another template or tenant.",
  "exported": "Template exported.",
  "import": "Import",
  "importHint": "Replace the canvas with a previously exported design. Save to keep it.",
  "imported": "Design imported. Save to keep it.",
  "importFailed": "That file is not a valid signature template.",
  "clone": "Clone",
  "cloneHint": "Create a copy of this template with the current design.",
  "cloned": "Template cloned.",
  "cloneFailed": "Could not clone that template.",
  "cloneNameSuffix": " (copy)",
  "palette": "Blocks",
  "inspector": "Inspector",
  "canvas": "Canvas",
  "unsaved": "Unsaved changes",
  "unsavedShort": "Unsaved",
  "checking": "Checking…",
  "saved": "Template saved.",
  "saveError": "Could not save that template.",
  "saveFailed": "Save failed.",
  "statusDraft": "Draft",
  "statusPublished": "Published",
  "statusArchived": "Archived",
  "createTitle": "New template",
  "templateName": "Template name",
  "templateNamePlaceholder": "Corporate — full",
  "create": "Create",
  "createError": "Could not create template",
  "blockRow": "Row",
  "blockColumn": "Column",
  "blockText": "Text",
  "blockImage": "Image",
  "blockSpacer": "Spacer",
  "blockDivider": "Divider",
  "blockSocial": "Social icons",
  "blockBanner": "Banner slot",
  "blockButton": "Button",
  "blockDisclaimer": "Disclaimer",
  "blockGeneric": "Block",
  "addRow": "Add row",
  "twoColumns": "Two columns",
  "threeColumns": "Three columns",
  "paletteHelp": "Columns are added and resized from the row's inspector. Rows cannot go inside a column — nested tables are where Outlook rendering breaks.",
  "deleteBlock": "Delete block",
  "duplicateBlock": "Duplicate block",
  "noSelection": "Select a block to edit its properties.",
  "content": "Content",
  "style": "Style",
  "layout": "Layout",
  "previewTitle": "Preview",
  "previewAs": "Preview as",
  "previewNamed": "Preview — {{name}}",
  "previewSignature": "Preview signature",
  "closePreview": "Close preview",
  "compilerWarnings_one": "{{count}} compiler warning",
  "compilerWarnings_other": "{{count}} compiler warnings",
  "compilerWarningsHint": "From the same compiler that runs at publish. Blocks with a warning are flagged on the canvas.",
  "sketchBadge": "Sketch",
  "sketchHint": "Layout only — spacing, fonts and Outlook quirks are not reproduced here. Open the preview for what the mail actually looks like.",
  "canvasEmpty": "Drag a block from the palette, or click one to add it.",
  "emptyColumn": "Empty column",
  "reorderRow": "Reorder row",
  "reorderBlock": "Reorder {{block}}",
  "markerExternalOnly": "external only",
  "markerNewMessagesOnly": "new messages only",
  "markerConditions_one": "{{count}} condition",
  "markerConditions_other": "{{count}} conditions",
  "placeholderImageNoSource": "Image — no source set",
  "placeholderImageMerge": "Image — merge field source",
  "placeholderSocialEmpty": "Social icons — none added",
  "placeholderBanner": "Campaign banner — artwork comes from the active campaign at send time",
  "sampleProfilePhotoAlt": "Sample profile photo",
  "sampleProfilePhotoTitle": "Sample profile photo — each sender's real photo is used at send time",
  "theme": "Theme",
  "themeHint": "Applied to the whole signature. Web-safe stacks only — Outlook will not load a web font and Gmail strips it, so a signature that depends on one looks different for most of its readers.",
  "appliesTo": "Applies to",
  "font": "Font",
  "baseSizePx": "Base size (px)",
  "textColour": "Text colour",
  "linkColour": "Link colour",
  "background": "Background",
  "backgroundHint": "Usually best left unset. Dark-mode clients recolour light panels, which is how a signature ends up as a white box in a dark thread.",
  "clearBackground": "Clear background",
  "maxWidthPx": "Maximum width (px)",
  "maxWidthPxHint": "Leave blank for Auto — the signature table is not capped.",
  "maxWidthBannerHint": "Leave blank for Auto — the banner scales to the signature width.",
  "hideWhenNoPhoto": "Hide when the sender has no photo",
  "hideWhenBlank": "Hide when its fields are blank",
  "hideWhenNoPhotoHint": "Profile photos always omit the portrait (and its column) when the directory has none — a blank face slot is never useful.",
  "hideWhenBlankHint": "Stops a user with no mobile number ending up with an orphaned 'M:' and a stray separator.",
  "includeInReplies": "Include in replies and forwards",
  "includeInRepliesHint": "Turn off for logos and disclaimers, which become noise on the fourth message of a thread.",
  "recipients": "Recipients",
  "audienceEveryone": "Everyone",
  "audienceExternalOnly": "External only",
  "showOnlyWhen": "Show only when",
  "visibleWhenEmptyHint": "Always shown. Add a condition to limit this block to some users.",
  "alignment": "Alignment",
  "alignLeft": "Left",
  "alignCentre": "Centre",
  "alignRight": "Right",
  "paddingTop": "Padding top",
  "paddingBottom": "Padding bottom",
  "columns": "Columns",
  "columnsHint": "Columns are added and removed here rather than dragged, because a column only means anything inside its row.",
  "columnWidth": "Column {{n}} width",
  "placeholderAuto": "Auto",
  "placeholderTheme": "Theme",
  "removeColumn": "Remove column {{n}}",
  "editColumn": "Edit",
  "addColumn": "Add column",
  "widthPx": "Width (px)",
  "widthPxHint": "Left blank the column shares the remaining space. Fixed widths survive the Word engine better than percentages.",
  "verticalAlign": "Vertical alignment",
  "alignTop": "Top",
  "alignMiddle": "Middle",
  "alignBottom": "Bottom",
  "padLeft": "Pad left",
  "padRight": "Pad right",
  "padTop": "Pad top",
  "padBottom": "Pad bottom",
  "text": "Text",
  "sizePx": "Size (px)",
  "lineHeight": "Line height",
  "colour": "Colour",
  "bold": "Bold",
  "italic": "Italic",
  "link": "Link",
  "disclaimerText": "Disclaimer text",
  "imageUrl": "Image URL",
  "imageUrlHint": "Absolute HTTPS, or {{photoToken}} for each sender's directory photo. Gmail will not render an embedded attachment, so images are always hosted.",
  "useProfilePhoto": "Use profile photo",
  "chooseFromLibrary": "Choose from library",
  "clear": "Clear",
  "profilePhotoHint": "At send time this becomes the sender's photo. People without one lose the portrait and its column entirely — never a broken image or an empty face-sized gap.",
  "heightPx": "Height (px)",
  "unlockAspect": "Unlock aspect ratio",
  "lockAspect": "Lock aspect ratio",
  "autoSize": "Auto",
  "autoProfileHint": "Sets {{size}}×{{size}} for the portrait slot.",
  "autoNaturalHint": "Uses the image's natural size (capped for signatures).",
  "autoNeedSource": "Add an image URL or pick one from the library first.",
  "autoNeedHttps": "Auto needs an https:// image URL to measure.",
  "autoMeasureFailed": "Could not read that image's size. Check the URL loads in a browser.",
  "aspectLocked": "Aspect ratio locked — changing one side scales the other.",
  "aspectUnlocked": "Aspect ratio unlocked — width and height edit independently.",
  "dimensionsHint": "Both dimensions are emitted as HTML attributes. Without them the Word engine rescales the image on any display above 96 DPI, which is most of them.",
  "altText": "Alt text",
  "profilePhotoAlt": "Profile photo",
  "frame": "Frame",
  "frameHint": "Borders and soft shadows appear in modern clients. Classic Outlook keeps the border and ignores radius and shadow.",
  "frameColour": "Frame colour",
  "frameNone": "None",
  "frameThin": "Thin",
  "frameThick": "Thick",
  "frameRounded": "Rounded",
  "frameCircle": "Circle",
  "frameSoftShadow": "Soft shadow",
  "effect": "Effect",
  "effectHint": "Bakes an email-safe animated GIF. Outlook desktop often freezes on the finished still; Gmail and others play the motion.",
  "effectProfileHint": "Effects need a hosted library image or HTTPS URL — not a profile photo merge field.",
  "effectNeedHttps": "Add an https:// image or choose one from the library before applying an effect.",
  "effectConverting": "Converting to animated GIF…",
  "effectApplyFailed": "Could not apply that effect.",
  "effectNone": "None",
  "effectWhipFlip": "Whip Flip",
  "effectDottedGloom": "Dotted Gloom",
  "effectGlowSway": "Glow Sway",
  "effectInvertedChaos": "Inverted Chaos",
  "effectHaloBlur": "Halo Blur",
  "effectBlur": "Blur",
  "effectMirror": "Mirror",
  "effectFadeOut": "Fade Out",
  "effectLowExposure": "Low Exposure",
  "effectColorsOff": "Colors Off",
  "networkPlaceholder": "Network",
  "removeIcon": "Remove {{name}}",
  "iconFallback": "icon",
  "profileUrl": "Profile URL",
  "profileUrlPlaceholder": "Profile URL — may be a merge field",
  "iconImageUrl": "Icon image URL",
  "iconImageUrlPlaceholder": "Icon image URL",
  "addIcon": "Add icon",
  "socialIconsHint": "An icon whose link resolves blank drops out on its own, so a user with no LinkedIn profile does not get a dead icon.",
  "platformLabel": "Platform",
  "platformLinkedIn": "LinkedIn",
  "platformX": "X",
  "platformFacebook": "Facebook",
  "platformInstagram": "Instagram",
  "platformYouTube": "YouTube",
  "platformTikTok": "TikTok",
  "platformThreads": "Threads",
  "platformGitHub": "GitHub",
  "platformWhatsApp": "WhatsApp",
  "platformWebsite": "Website",
  "platformOther": "Other",
  "chooseIconFromLibrary": "Choose icon from library",
  "useDefaultIcon": "Use default icon",
  "iconOverrideHint": "Leave blank only for Other without an image. Defaults are HTTPS URLs hosted with the product.",
  "iconAlt": "Alt text",
  "moveIconUp": "Move icon left",
  "moveIconDown": "Move icon right",
  "iconMustBeHttps": "Icon image must be an https:// URL so it can appear in mail.",
  "spacingPx": "Spacing (px)",
  "bannerSlotHint": "The artwork and link come from whichever campaign is running when the message is sent, so marketing can start and end a banner without anyone reopening this template.",
  "label": "Label",
  "url": "URL",
  "buttonWidth": "Width",
  "buttonHeight": "Height",
  "cornerRadius": "Corner radius",
  "fontSize": "Font size",
  "thicknessPx": "Thickness (px)",
  "dividerHint": "Drawn as a filled table cell rather than an hr element, which clients style inconsistently.",
  "insertField": "Insert field",
  "searchFields": "Search fields",
  "noFieldMatch": "No field matches that.",
  "mergeFieldProblem": "Merge field problem",
  "emptyText": "Empty text",
  "groupThisTenant": "This tenant",
  "groupUser": "User",
  "groupOrganisation": "Organisation",
  "groupCampaign": "Campaign",
  "fieldDisplayName": "Display name",
  "fieldGivenName": "First name",
  "fieldSurname": "Last name",
  "fieldJobTitle": "Job title",
  "fieldDepartment": "Department",
  "fieldPrimaryEmail": "Email address",
  "fieldPhotoUrl": "Profile photo (image URL)",
  "fieldMobilePhone": "Mobile",
  "fieldBusinessPhone": "Phone",
  "fieldOfficeLocation": "Office",
  "fieldCity": "City",
  "fieldCountry": "Country",
  "fieldTenantName": "Organisation name",
  "fieldTenantSlug": "Organisation slug",
  "fieldCampaignAlt": "Banner alt text",
  "fieldCampaignUrl": "Banner link",
  "dirtyPreviewTitle": "Showing the last saved version",
  "dirtyPreviewBody": "The preview renders what is stored, not what is on the canvas. Save to refresh it.",
  "desktopWidth": "Desktop 600px",
  "mobileWidth": "Mobile 320px",
  "darkMode": "Dark mode",
  "darkModeTooltip": "An approximation only: the colours are inverted and rotated, which is not what any real client does. Outlook, Gmail and Apple Mail each recolour differently and some leave light backgrounds alone entirely. Use it to spot a signature that disappears, not to sign off on colours.",
  "darkModeHint": "Approximate. Real clients recolour differently — treat this as a smoke test, not a proof.",
  "renderWarnings": "Render warnings",
  "renderError": "Could not render the preview",
  "iframeTitle": "Signature preview — {{context}}",
  "contextNew": "New",
  "contextReply": "Reply",
  "contextNewExternal": "New (external)",
  "contextReplyExternal": "Reply (external)",
  "contextGmail": "Gmail",
  "contextAddIn": "Add-in",
  "contextPlainText": "Plain text",
  "testAs": "Test as",
  "testAsHint": "Merge fields and photo come from this mailbox. Clear to use the sample person.",
  "loadingMailboxes": "Loading mailboxes…",
  "samplePerson": "Sample person",
  "noMailboxMatch": "No mailbox matches that search.",
  "selectedMailbox": "Selected mailbox",
  "excludedSuffix": " (excluded)",
  "gmailBudget": "Gmail size budget",
  "gmailCharacters": "{{used}} / {{max}} characters",
  "gmailWillTruncate": "Gmail will truncate",
  "gmailNearLimit": "Close to the limit",
  "assetPickerTitle": "Choose an image",
  "assetPickerHint": "Hosted images, fetched by the recipient's mail client. PNG, JPEG, GIF or WebP.",
  "uploadImage": "Upload an image",
  "uploadWarningTitle": "Uploaded, but worth a look",
  "assetsEmpty": "No images yet. Upload one and it will appear here for every signature in this tenant.",
  "alreadyInLibrary": "That image was already in the library, so the existing one was used.",
  "uploadFailed": "That image could not be uploaded.",
  "deleteFailedTitle": "Not deleted",
  "deleteFailed": "That image could not be deleted.",
  "deleteAsset": "Delete {{name}}",
  "useThisAsset": "Use this"
}
